import { useContext, useEffect, useState } from "react";
import {
  DropdownsContext,
  DropdownsProvider,
} from "../../../../contexts/DropdownsContext";
import "./NewQuote.css";
import Dropdowns from "../../../../components/Dropdowns/Dropdowns";
import Skeleton from "react-loading-skeleton";
import { set } from "react-hook-form";
import { use } from "react";
import { createRFQ } from "../../Services/QuoteService";
const dropdownIds = [17, 19, 106, 107, 103];
const dropdownNames = {
  106: "orderType",
  107: "priority",
  103: "vendorId",
  17: "locationId",
  19: "siteId",
};
const defaultEmptyValues = {
  orderType: null,
  priority: null,
  locationId: null,
  siteId: null,
};
const NewQuoteBody = ({ parts, okAction, setValues, values }) => {
  const {
    dropdownsData,
    setDropdownsData,
    setDropdownIds,
    dropdownDefaultOptions,
  } = useContext(DropdownsContext);
  const [displayForm, setDisplayForm] = useState(false);
  const [vendorsSelected, setVendorsSelected] = useState([]);
  const [vendorToDelete, setVendorToDelete] = useState(null);
  const [clearExternalFilters, setClearExternalFilters] = useState(null);
  const [companyParameter, _] = useState([
    { columnName: "companyId", value: localStorage.getItem("u_company_id") },
  ]);
;
  
  useEffect(() => {
    setDropdownIds(dropdownIds);
  }, []);

  useEffect(() => {
    if (dropdownsData && dropdownsData.length > 0) {
      setDisplayForm(true);
    }
  }, [dropdownsData]);

  const simpleDropdownApply = (values) => {
    if (values.length === 0) {
      setVendorsSelected([]);
    }
    values.map((value) => {
      setVendorsSelected((prev) => {
        const existingVendor = prev.find((v) => v.id === value.id);
        if (existingVendor) {
          return prev.filter((v) => v.id !== value.id);
        } else {
          return [...prev, { id: value.id, name: value.name }];
        }
      });
    });
  };

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };
  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };
  const okActionHandle = () => {
    if (vendorsSelected?.length > 0) {
      okAction(vendorsSelected);
    }
  };
  const emptyFilters = () => {
    setClearExternalFilters(new Date().getTime());
    setVendorsSelected([]);
  };
  const handleDeleteVendor = (vendorId) => {
    setVendorToDelete(vendorId);
    setVendorsSelected((prev) => prev.filter((v) => v.id !== vendorId));
  };
  const handleDropdownValue = (value, name, data) => {
    changeValue({
      target: {
        name: name,
        value: value[data],
        completeValue: value,
      },
    });
  };
  const changeValue = (e) => {
    const { name, value, completeValue } = e.target;
    setValues((prev) => {
      return {
        ...prev,
        ...{ [name]: value },
      };
    });
  };
  return (
    <div className="new-quote-container-body">
      <div className="new-quote-contianer-body-dropdowns">
        {displayForm ? (
          <Dropdowns
            context={{
              dropdownsData,
              setDropdownsData,
              setDropdownIds,
              dropdownDefaultOptions,
            }}
            updateDropdown={updateDropdown}
            resetDropdownsReload={resetDropdownsReload}
            required={true}
            key={17}
            onOptionSelect={(value, data) =>
              handleDropdownValue(value, dropdownNames[17], data)
            }
            hideRequiredLabel={true}
            parameters={companyParameter}
            showPagination={false}
            data={dropdownsData.find((e) => e.id === 17)}
          />
        ) : (
          <Skeleton height="2rem" width="100%" />
        )}
        {displayForm ? (
          <Dropdowns
            context={{
              dropdownsData,
              setDropdownsData,
              setDropdownIds,
              dropdownDefaultOptions,
            }}
            updateDropdown={updateDropdown}
            resetDropdownsReload={resetDropdownsReload}
            required={true}
            key={19}
            onOptionSelect={(value, data) =>
              handleDropdownValue(value, dropdownNames[19], data)
            }
            hideRequiredLabel={true}
            parameters={companyParameter}
            showPagination={false}
            data={dropdownsData.find((e) => e.id === 19)}
          />
        ) : (
          <Skeleton height="2rem" width="100%" />
        )}
        {displayForm ? (
          <Dropdowns
            context={{
              dropdownsData,
              setDropdownsData,
              setDropdownIds,
              dropdownDefaultOptions,
            }}
            updateDropdown={updateDropdown}
            resetDropdownsReload={resetDropdownsReload}
            required={true}
            key={106}
            onOptionSelect={(value, data) =>
              handleDropdownValue(value, dropdownNames[106], data)
            }
            hideRequiredLabel={true}
            parameters={companyParameter}
            showPagination={false}
            data={dropdownsData.find((e) => e.id === 106)}
          />
        ) : (
          <Skeleton height="2rem" width="100%" />
        )}
        {displayForm ? (
          <Dropdowns
            context={{
              dropdownsData,
              setDropdownsData,
              setDropdownIds,
              dropdownDefaultOptions,
            }}
            updateDropdown={updateDropdown}
            resetDropdownsReload={resetDropdownsReload}
            required={true}
            key={107}
            onOptionSelect={(value, data) =>
              handleDropdownValue(value, dropdownNames[107], data)
            }
            hideRequiredLabel={true}
            parameters={companyParameter}
            showPagination={false}
            data={dropdownsData.find((e) => e.id === 107)}
          />
        ) : (
          <Skeleton height="2rem" width="100%" />
        )}
        {displayForm ? (
          <Dropdowns
            context={{
              dropdownsData,
              setDropdownsData,
              setDropdownIds,
              dropdownDefaultOptions,
            }}
            key={103}
            data={dropdownsData.find((e) => e.id === 103)}
            updateDropdown={updateDropdown}
            resetDropdownsReload={resetDropdownsReload}
            onApplySelection={simpleDropdownApply}
            deleteSingleOption={vendorToDelete}
            columnSingleDelete={"id"}
            preselectValue={vendorsSelected}
            clearExternalFilters={clearExternalFilters}
            parameters={companyParameter}
          />
        ) : (
          <Skeleton height="1.9rem" width="100%" />
        )}
      </div>
      <div className="title-quote-vendors-selected">
        <b>Selected</b>
        <p onClick={() => emptyFilters()}>Clear All</p>
      </div>
      <div className="vendors-selected-container">
        <div className="vendor-selected-list">
          {vendorsSelected?.length > 0 ? (
            vendorsSelected?.map((vendor, index) => (
              <div className="vendor-selected-item" key={index}>
                <div className="title-vendor-selected">
                  <i className="icon-check-3"></i>
                  <span>{vendor.name}</span>
                </div>

                <i
                  className="icon-delete-new"
                  onClick={() => {
                    handleDeleteVendor(vendor.id);
                  }}
                ></i>
              </div>
            ))
          ) : (
            <div className="no-vendors-selected">
              <p>No vendors selected</p>
            </div>
          )}
        </div>
      </div>
      <button
        onClick={okActionHandle}
        className={`filled iconTextButton greenButton ${
          !vendorsSelected || vendorsSelected.length == 0 ? "disabled" : ""
        }`}
      >
        <i className="icon-quote"></i> <span>Send Quote Request</span>
      </button>
    </div>
  );
};
const NewQuote = ({ onClose, parts, okAction }) => {
  const [values, setValues] = useState({ ...defaultEmptyValues });
  const handleOkAction = (vendors) => {
    const quoteDetails = [];
    vendors.forEach((vendor) => {
      parts.forEach((partRequest) => {
        if (partRequest.toOrder) {
          quoteDetails.push({
            partRequestId: partRequest.id,
            partId: partRequest.part_id,
            companyId: partRequest.company_id,
            vendorId: vendor.id,
            quantity: partRequest.quantity,
            status: "Pending",
          });
        }
      });
    });
    const quoteDate = {
      status: "Pending",
      dateSent: new Date().toISOString(),
      companyId: parts[0].company_id,
      orderType: values.orderType,
      priority: values.priority,
      locationId: values.locationId,
      siteId: values.siteId,
      details: quoteDetails,
    };
    createRFQ(quoteDate)
      .then((response) => {
        if (response.data.load) {
          okAction(response.data.load, vendors);
          onClose();
        } else {
          console.error("Error creating RFQ:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error creating RFQ:", error);
      });
  };
  return (
    <div className="new-quote-container">
      <div className="new-quote-contianer-header">
        <b>Choose Vendors to Quote</b>
        <button className="outlined icon small-size" onClick={onClose}>
          <i className="icon-cross"></i>
        </button>
      </div>
      <hr></hr>
      <DropdownsProvider>
        <NewQuoteBody
          parts={parts}
          okAction={handleOkAction}
          setValues={setValues}
          values={values}
        />
      </DropdownsProvider>
    </div>
  );
};

export default NewQuote;
